import { StatiscalAnalysisTypeCases, StatisticalAnalysisDossiers } from '@/modules/statistical-analysis-module/shared/models/shared.model'
import { StatisticalAnalysisGroupingResponse } from '@/modules/statistical-analysis-module/shared/services/statistical-analysis-grouping/statistical-analysis-grouping.dto'
import axios from 'axios'

class StatisticalAnalysisGroupingService {
    async getFieldsGrouping(dossier: StatisticalAnalysisDossiers, typeSearch: StatiscalAnalysisTypeCases[]): Promise<StatisticalAnalysisGroupingResponse> {
        let params = {
            entityList: typeSearch
        }
        const response = await axios.get<StatisticalAnalysisGroupingResponse>(`/statisticAnalysis/dossiers/${dossier}/groupFields`, { params })
        return response.data
    }
}

export const statisticalAnalysisGroupingService = new StatisticalAnalysisGroupingService()
